import React from 'react';
import { PayPalSelector } from 'Features/PaymentMethodSelector/PaymentSelector/PayPalSelector';
import { ApplePayButton } from 'Components/ApplePay/ApplePayButton';
import { SubmitButton } from 'Components/Fields/Buttons';

import './SubmitPaymentButton.css';

export const SubmitPaymentButton = ({
  paymentType,
  hasSavedPayment,
  handlePayment,
  trackPaymentAction,
  submitButtonText,
  isDisabled,
  submitPaymentForm,
  submitting,
  isObstructed,
  setIsSubmitting,
  className = 'desktopSubmitPaymentButton',
}) => {
  return (
    <div className={`${className}${isObstructed ? ' keyboardActive' : ''}`}>
      {paymentType === 'paypal' &&
        (hasSavedPayment ? (
          <SubmitButton
            text={submitButtonText}
            submitting={submitting}
            isDisabled={isDisabled}
            isObstructed={isObstructed}
            modernLayout
            onClick={() => {
              setIsSubmitting(true);
              trackPaymentAction('paypal');
              submitPaymentForm(paymentType);
            }}
          />
        ) : (
          <PayPalSelector handlePayment={handlePayment} submitButtonText={submitButtonText} idName={className} />
        ))}
      {paymentType === 'apple pay' && (
        <ApplePayButton
          submitButtonText={submitButtonText}
          onClick={(data) => {
            setIsSubmitting(true);
            trackPaymentAction('apple pay');
            handlePayment('apple pay', data, paymentType);
          }}
        />
      )}
      {paymentType === 'direct credit card' && (
        <SubmitButton
          text={submitButtonText}
          submitting={submitting}
          isDisabled={isDisabled}
          isObstructed={isObstructed}
          modernLayout
          onClick={() => {
            setIsSubmitting(true);
            submitPaymentForm(paymentType);
          }}
        />
      )}
    </div>
  );
};
